import { render } from "./DashboardThemeUpsert.vue?vue&type=template&id=162cf535"
import script from "./DashboardThemeUpsert.vue?vue&type=script&lang=js"
export * from "./DashboardThemeUpsert.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__